import * as St from './PunchHoleItem.styles';

export type IPunchHoleItem = {
  icon: JSX.Element;
  title: string;
  content: string;
  link?: {
    href: string;
    text: string;
  };
};

export const PunchHoleItem = ({
  icon,
  title,
  content,
  link,
}: IPunchHoleItem) => (
  <St.Container>
    {icon}
    <St.Content>
      <St.Title>{title}</St.Title>
      <St.Description>{content}</St.Description>
      {link && (
        <St.Link
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          download
        >
          {link.text}
        </St.Link>
      )}
    </St.Content>
  </St.Container>
);

export default PunchHoleItem;
